export type Depth = "plain" | "clear" | "deep";

export type ApiTerm = {
  term: string;
  slug?: string;
  chapter: string;
  plain: string;
  clear: string;
  deep: string;
  source?: string | null;
  sourceLabel?: string | null;
};

export type ApiTopic = {
  id: string;
  title: string;
  summary?: string;
  sort_order?: number;
};

export type ApiLesson = {
  slug: string;
  chapter: string;
  title: string;
  summary: string;
  body: string;
  sort_order?: number;
  source?: string | null;
};

export type ApiTimelineEvent = {
  year: string;
  title: string;
  summary: string;
  tag?: string | null;
  source?: string | null;
  sort_order?: number;
};

export type ApiFaq = {
  question: string;
  answer: string;
  chapter: string;
  sort_order?: number;
  source?: string | null;
};

export type ApiQuiz = {
  lesson_slug: string;
  question: string;
  choices: string[];
  answer_index: number;
  explain?: string | null;
  sort_order?: number;
};

export type TermsPayload = {
  ok: boolean;
  count: number;
  topics: ApiTopic[];
  terms: ApiTerm[];
};

export type CurriculumPayload = {
  ok: boolean;
  topics?: ApiTopic[];
  lessons?: ApiLesson[];
  timeline?: ApiTimelineEvent[];
  faqs?: ApiFaq[];
  terms?: ApiTerm[];
  quizzes?: ApiQuiz[];
  termCount?: number;
  counts?: Record<string, number | null>;
};

export async function fetchCurriculum(): Promise<TermsPayload | null> {
  try {
    const API_URL = new URL("../api/terms.php", window.location.href).href;
    const res = await fetch(API_URL, { credentials: "omit" });
    if (!res.ok) return null;
    const data = (await res.json()) as TermsPayload;
    if (!data?.ok || !Array.isArray(data.terms)) return null;
    return data;
  } catch {
    return null;
  }
}

export async function fetchFullCurriculum(): Promise<CurriculumPayload | null> {
  try {
    const API_URL = new URL("../api/curriculum.php", window.location.href).href;
    const res = await fetch(API_URL, { credentials: "omit" });
    if (!res.ok) return null;
    const data = (await res.json()) as CurriculumPayload;
    if (!data?.ok) return null;
    return data;
  } catch {
    return null;
  }
}

export function textForDepth(term: ApiTerm, depth: Depth): string {
  if (depth === "plain") return term.plain;
  if (depth === "clear") return term.clear;
  return term.deep;
}
